/**
 * ERC Clay B2B Override v2.0
 */
(function() {
  'use strict';

  var realFetch = window.__ercRealFetch || window.fetch;

  // 锁死 fetch，防止 Clay 异步加载后再次覆盖
  try {
    Object.defineProperty(window, 'fetch', {
      get: function() { return realFetch; },
      set: function() { /* block Clay's re-patch */ },
      configurable: true
    });
  } catch(e) {
    window.fetch = realFetch;
  }

  function unlockButtons() {
    var selectors = ['[name="add"]', '.product-form__submit', '[data-add-to-cart]'];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(btn) {
        btn.removeAttribute('disabled');
        var text = btn.innerText || btn.textContent || '';
        if (/sold.?out/i.test(text)) {
          var spans = btn.querySelectorAll('span:not(.visually-hidden)');
          if (spans.length > 0) spans[0].textContent = 'Add to cart';
          else btn.textContent = 'Add to cart';
        }
        // 克隆按钮，清除 Clay 绑定的所有事件监听器
        if (btn.parentNode) {
          var clone = btn.cloneNode(true);
          btn.parentNode.replaceChild(clone, btn);
        }
      });
    });
  }

  function removeSoldOutErrors() {
    document.querySelectorAll('*').forEach(function(el) {
      if (el.children.length > 0) return;
      var text = el.textContent || '';
      if (/already sold out/i.test(text)) {
        var t = el;
        for (var i = 0; i < 6; i++) {
          if (!t.parentElement) break;
          t = t.parentElement;
          var tag = (t.tagName || '').toLowerCase();
          if (tag === 'p' || tag === 'div' || tag === 'li') {
            t.style.cssText = 'display:none!important;';
            break;
          }
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    unlockButtons();
    removeSoldOutErrors();
    [400, 1000, 2500].forEach(function(d) {
      setTimeout(function() { unlockButtons(); removeSoldOutErrors(); }, d);
    });

    if (window.MutationObserver) {
      new MutationObserver(function() {
        setTimeout(function() { unlockButtons(); removeSoldOutErrors(); }, 80);
      }).observe(document.body, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['disabled', 'class']
      });
    }
  });

})();